import { generateEnvoyConsentHeader as a, X_ALLOW_COOKIES as o, X_BLOCK_COOKIES as r, X_CSRF_Token as c } from "./oneTrust.js";
function f() {
  const e = /* @__PURE__ */ new Map(), t = document.querySelector("meta[name=csrf-token]"), s = t && t.getAttribute("content"), n = a();
  return e.set(o, n[o]), e.set(r, n[r]), e.set(c, s ?? ""), e;
}
export {
  f as getDefaultRequestHeaders
};
